t <template>
  <modal id="trial-used-modal" anchor="#us" centered size="md" title-tag="h3" title="Subscribe to CloudApp" :hide-header-close="true" :hide-footer="true" :no-close-on-backdrop="true">
    <b-img center src="@img/logos-cloud-app-logomark-full-color.svg" width="100" alt="CloudApp Logo"/>
    <p>To unlock this feature and more you will need a CloudApp subscription</p>
    <div class="justify-content-center d-flex flex-column align-items-center">
      <div class="d-inline-block">
        <ul class="text-left offer_features">
          <li class="item">Unlimited video recording</li>
          <li class="item">Custom branding</li>
          <li class="item">Custom buttons</li>
          <li class="item">Search and unlimited history</li>
          <li class="item">Privacy controls</li>
          <li class="item">Template presets</li>
          <li class="item">And more &hellip;</li>
        </ul>
      </div>

      <button type="button" @click="acceptOffer()" class="cloudapp-btn blue">Subscribe</button><br>
      <span class="d-inline-block offer_decline mt-2" @click="declineOffer()">Maybe later</span>
    </div>
  </modal>
</template>

<script>
import Modal from "@cmp/modal.vue";

export default {
  components: { Modal },
  methods: {
    declineOffer: function() {
      this.$bvModal.hide("trial-used-modal");
    },
    acceptOffer: function(){
      window.location.href = this.$root.routes.plans_path();
    }
  }
}
</script>

<style lang="scss" scoped>
  img#gift {
    width: 100px;
  }

  ul.offer_features {
    margin-top: 1rem;
    margin-bottom: 1rem;

    font-size: 12pt;
    font-weight: 400;
    list-style: none;

    li.item:before {
      content: "\002714\00a0";
    }
  }

  span.offer_decline {
    color: rgb(115, 130, 145);
    font-size: 10pt;
    cursor: pointer;
  }
</style>
